/**
 *
 * MeasurementSelectRecipient
 *
 */

import React from "react"
// import PropTypes from 'prop-types';
import { Input, Button, message, Tooltip } from "antd"
import { filter, flatMap, debounce, isEqual } from "lodash"
import { copyToClipboard } from "../../utils/utils"
import MeasurementSelectRecipientTable from "../MeasurementSelectRecipientTable"
import "./index.less"
import { SearchOutlined, UploadOutlined } from "@ant-design/icons"
import history from "utils/history"
import Loader from "components/Loader"
import { LOCAL_USER_ID } from "../../utils/storage"
import { buttonAction_s } from "../Snowplow/config2"

const recursiveFindChildsId = (array = [], data) => {
  array.push(data)
  if (data.children && data.children.length > 0) {
    data.children.map((e) => recursiveFindChildsId(array, e))
  }
  return array
}
// snowplow
let data_button = {
  category: window.location.hash
    ? window.location.hash
    : window.location.pathname,
  action: "Copiar link",
  label: "Click a Copiar link",
  property: "Button",
  value: LOCAL_USER_ID(),
}
// snowplow
let data_button_import = {
  category: window.location.hash
    ? window.location.hash
    : window.location.pathname,
  action: "Importar destinatarios",
  label: "Click a Importar destinatarios",
  property: "Button",
  value: LOCAL_USER_ID(),
}
/* eslint-disable react/prefer-stateless-function */
class MeasurementSelectRecipient extends React.Component {
  linkCuestionaryRef = React.createRef()
  state = {
    dataTreeDivisions: [],
    descendents: [],
    stateSelectedRows: [],
    employeesSelected: [],
    firstLoad: true,
    searchDivisions: "",
  }

  sendToServer = () => {
    this.props.stepRecipientsWatcher({
      idMeasurement: this.props.idMeasurement,
      params: {
        employees: this.state.employeesSelected,
        divisions: this.state.stateSelectedRows,
        auto_save: true,
      },
    })
  }

  sendToServerDebounce = debounce(this.sendToServer, 500)

  componentDidMount = () => {
    this.props.stepRecipientsWatcher({
      idMeasurement: this.props.idMeasurement,
    })
    // const employeesFlatMap = flatMap(this.props.divisions.data, item => item.id_division);
    this.setState(
      {
        dataTreeDivisions: this.props.divisions.dataTree,
        employeesSelected: this.props.recipientsStepData.employees,
        stateSelectedRows: this.props.recipientsStepData.divisions,
        // descendents: this.props.secondStepData.divisions.length || this.props.secondStepData.employees.length ? employeesFlatMap : []
      },
      () => {
        // this.props.setStateFrom('divisionsSelected', this.state.stateSelectedRows);
        this.props.setStateFrom(
          "collaboratorsSelected",
          this.state.employeesSelected
        )
      }
    )
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (!isEqual(prevProps.recipientsStepData, this.props.recipientsStepData)) {
      this.setState(
        {
          dataTreeDivisions: this.props.divisions.dataTree,
          employeesSelected: this.props.recipientsStepData.employees,
          stateSelectedRows: this.props.recipientsStepData.divisions,
          // descendents: this.props.secondStepData.divisions.length || this.props.secondStepData.employees.length ? employeesFlatMap : []
        },
        () => {
          // this.props.setStateFrom('divisionsSelected', this.state.stateSelectedRows);
          this.props.setStateFrom(
            "collaboratorsSelected",
            this.state.employeesSelected
          )
          this.props.setStateFrom(
            "selectedEmployees",
            this.state.employeesSelected
          )
        }
      )
    }
    if (!isEqual(prevState.employeesSelected, this.state.employeesSelected)) {
      this.props.setStateFrom("selectedEmployees", this.state.employeesSelected)
    }
    if (prevProps.divisions.data.length !== this.props.divisions.data.length) {
      this.setState({ dataTreeDivisions: this.props.divisions.dataTree })
    }

    if (prevProps.descendents.length !== this.props.descendents.length) {
      const employeesFilter = filter(this.props.divisions.data, (item) =>
        this.props.descendents.includes(item.id_division)
      )
      const employeesFlatMap = flatMap(
        employeesFilter,
        (item) => item.employees
      )
      const employeesIds = flatMap(employeesFlatMap, (item) => item.id_employee)
      if (!this.state.stateSelectedRows.length) {
        return this.setState(
          {
            employeesSelected: [
              ...employeesIds,
              ...this.state.employeesSelected,
            ],
            descendents: [...this.props.descendents, ...this.state.descendents],
            stateSelectedRows: this.props.descendents,
          },
          () => {
            // this.sendToServerDebounce()
            // this.props.setStateFrom('divisionsSelected', this.state.stateSelectedRows);
            this.props.setStateFrom(
              "collaboratorsSelected",
              this.state.employeesSelected
            )
          }
        )
      }

      this.setState(
        {
          employeesSelected: [...employeesIds, ...this.state.employeesSelected],
          descendents: [...this.props.descendents, ...this.state.descendents],
          stateSelectedRows: [
            ...this.props.descendents,
            ...this.state.stateSelectedRows,
          ],
        },
        () => {
          // this.sendToServerDebounce()
          this.props.setStateFrom(
            "divisionsSelected",
            this.state.stateSelectedRows
          )
          this.props.setStateFrom(
            "collaboratorsSelected",
            this.state.employeesSelected
          )
        }
      )
    }

    if (
      this.props.recipientsStepData.employees &&
      this.props.recipientsStepData.employees.length === 0 &&
      this.state.firstLoad
    ) {
      if (this.state.stateSelectedRows && this.state.descendents) {
        if (
          this.state.stateSelectedRows.length === 0 &&
          this.state.descendents.length === 0
        ) {
          this.setState({ firstLoad: false }, () => {
            const filterEmployeesDifferentZero = prevProps.divisions.data.filter(
              (item) => {
                return (
                  !!item.employees.length ||
                  item.children.some((item) => !!item.employees)
                )
              }
            )
          })
        }
      } else {
        this.setState({ firstLoad: false }, () => {
          const filterEmployeesDifferentZero = prevProps.divisions.data.filter(
            (item) => {
              return (
                !!item.employees.length ||
                item.children.some((item) => !!item.employees)
              )
            }
          )
        })
      }
    }
  }

  setStateFrom = (name, value, division = null) => {
    if (name === "employeesSelected") {
      const employeesIds = flatMap(
        division.employees,
        (item) => item.id_employee
      )
      const hasAllEmployees = filter(value, (item) =>
        employeesIds.includes(item)
      )

      if (employeesIds.length === hasAllEmployees.length) {
        this.setState({
          stateSelectedRows: [
            ...this.state.stateSelectedRows,
            division.id_division,
          ],
        })
      }

      if (hasAllEmployees.length === 0) {
        this.setState({
          stateSelectedRows: filter(
            this.state.stateSelectedRows,
            (item) => division.id_division !== item
          ),
        })
      }

      return this.setState({ employeesSelected: value }, () => {
        // this.sendToServerDebounce()
        this.props.setStateFrom(
          "divisionsSelected",
          this.state.stateSelectedRows
        )
        this.props.setStateFrom(
          "collaboratorsSelected",
          this.state.employeesSelected
        )
      })
    }

    if (name === "descendentsAll") {
      const employeesFlatMap = flatMap(
        this.props.divisions.data,
        (item) => item.employees
      )
      const employeesIds = flatMap(employeesFlatMap, (item) => item.id_employee)

      return this.setState(
        {
          descendents: value,
          stateSelectedRows: value,
          employeesSelected: employeesIds,
        },
        () => {
          // this.sendToServerDebounce()
          this.props.setStateFrom(
            "divisionsSelected",
            this.state.stateSelectedRows
          )
          this.props.setStateFrom(
            "collaboratorsSelected",
            this.state.employeesSelected
          )
        }
      )
    }

    if (name === "divisionsRemoveSelectedAll") {
      return this.setState(
        {
          stateSelectedRows: value,
          employeesSelected: value,
        },
        () => {
          // this.sendToServerDebounce()
          this.props.setStateFrom(
            "divisionsSelected",
            this.state.stateSelectedRows
          )
          this.props.setStateFrom(
            "collaboratorsSelected",
            this.state.employeesSelected
          )
        }
      )
    }

    this.setState({ [name]: value }, () => {
      // this.sendToServerDebounce()
      this.props.setStateFrom("divisionsSelected", this.state.stateSelectedRows)
      this.props.setStateFrom(
        "collaboratorsSelected",
        this.state.employeesSelected
      )
    })
  }

  openRows = (rows) => {
    this.setState({ descendents: rows })
  }

  deselectRows = (idCurrentRow, division = null) => {
    const employeesIds = []
    const div_id = []
    const divisions = recursiveFindChildsId([], division)
    divisions.map((e) => {
      div_id.push(e.id_division)
      e.employees.map((c) => {
        employeesIds.push(c.id_employee)
      })
    })

    this.setState(
      {
        stateSelectedRows: filter(
          this.state.stateSelectedRows,
          (item) => !div_id.includes(item)
        ),
        employeesSelected: filter(
          this.state.employeesSelected,
          (item) => !employeesIds.includes(item)
        ),
      },
      () => {
        // this.sendToServerDebounce()
        this.props.setStateFrom(
          "divisionsSelected",
          this.state.stateSelectedRows
        )
        this.props.setStateFrom(
          "collaboratorsSelected",
          this.state.employeesSelected
        )
      }
    )
  }

  searchWithDebounce = debounce((text) => {
    this.props.getDivisionsWatcher(text)
  }, 500)

  handleImport = () => {
    this.sendToServer()
    localStorage.setItem("currentMeasure", this.props.idMeasurement)
    buttonAction_s(data_button_import)
    history.push(
      `/models/measure/${this.props.idMeasurement}/import-recipients/`
    )
  }

  render() {
    return (
      <div className="measurement-select-recipient">
        <div className="measurement-select-recipient-header">
          <div>
            <div className="measurement-select-recipient-header-title">
              Seleccionar destinatarios
            </div>
            <div className="measurement-select-recipient-header-description">
              Selecciona las divisiones a las que deseas enviar la encuesta<span className="red">*</span>:
            </div>
            <div className="measurement-select-recipient-header-input">
              <Input
                allowClear
                placeholder="Buscar división..."
                suffix={
                  this.state.searchDivisions ? undefined : <SearchOutlined />
                }
                onChange={(e) => {
                  this.setState({ searchDivisions: e })
                  this.searchWithDebounce(e.target.value)
                }}
              />
              <Tooltip
                placement="bottom"
                title="Importar destinatarios"
                className="btn-tooltip">
                <Button
                  className="whiteButton"
                  size="default"
                  icon={<UploadOutlined />}
                  onClick={this.handleImport}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                />
              </Tooltip>
            </div>
          </div>
          <div className="measurement-select-recipient-header-copylink">
            <div>
              Recuerda que los destinatarios que no cuenten con correo
              electrónico <br /> deberán entrar al siguiente <span>link</span>{" "}
              con su DNI para responder la encuesta:
            </div>
            <div className="measurement-select-recipient-header-copylink-actions">
              <Input
                ref={this.linkCuestionaryRef}
                placeholder={`${process.env.QUESTIONNAIRE_URL}`}
                value={`${process.env.QUESTIONNAIRE_URL}`}
                disabled
              />
              <Button
                onClick={() => {
                  copyToClipboard(process.env.QUESTIONNAIRE_URL)
                  message.info("El link de la encuesta ha sido copiado.")
                  buttonAction_s(data_button)
                }}>
                Copiar link
              </Button>
            </div>
          </div>
        </div>
        <div className="measurement-select-recipient-content">
          {!this.props.isLoadingRecipientsStepData ? (
            <MeasurementSelectRecipientTable
              getDescendantsWatcher={this.props.getDescendantsWatcher}
              dataSource={this.state.dataTreeDivisions}
              descendents={this.state.descendents}
              isLoadingDescendents={this.props.isLoadingDescendents}
              stateSelectedRows={this.state.stateSelectedRows}
              employeesSelected={this.state.employeesSelected}
              setStateFrom={this.setStateFrom}
              deselectRows={this.deselectRows}
              openRows={this.openRows}
            />
          ) : (
            <Loader />
          )}
        </div>
      </div>
    )
  }
}

MeasurementSelectRecipient.propTypes = {}

export default MeasurementSelectRecipient
